module.exports = __webpack_public_path__ + "img/9_36.2ebeee58.png";